import { Box } from "@mui/material";
import React from "react";

type TDragDropParent = {
  children: React.ReactNode;
  hasFile: boolean;
  isDragging: boolean;
};

export default function DragDropParent({ hasFile, isDragging, children }: TDragDropParent) {
  return (
    <Box
      sx={{
        width: "100%",
        borderWidth: hasFile ? "0px" : "1px",
        borderStyle: "dashed",
        mt: "0.5rem",
        borderRadius: "5px",
        display: "flex",
        padding: "0.5rem",
        border: hasFile ? "0px" : isDragging ? "1px dashed #003087" : "1px dashed #BDBDBD",
        backgroundColor: isDragging ? "rgba(0, 48, 135, 0.1)" : "transparent",
        transition: "all 0.3s ease-in-out",
      }}
    >
      {children}
    </Box>
  );
}
